import React from 'react';
import { Route } from 'react-router-dom';
import Header from '../components/Header';

export const WrappedRoute = ({
  component: Component,
  heading,
  ...rest
}) => {

  return (
    <Route {...rest} component={(props) => (
      <>
        <Header heading={heading} history={props.history}/>
        <div className="container__wrapper">
          <Component {...props}/>
        </div>
      </>
    )} />
  );
}

export default WrappedRoute;
